import Validator from './validator.js';

export default class EmailAPIValidator extends Validator {
    constructor(input){
        super(input);
        this.url = input.el.dataset.emailApi;
        this.previous = {};
    }

    valid() {
        const email = this.input.el.value;
        if (!email) { return Promise.resolve(false); }
        if (email === this.previous.email) { return Promise.resolve(this.previous.valid); }

        return new Promise((resolve) => {
            fetch(this.url + `?emailId=${email}`)
                .then((response) => response.json())
                .then((result) => Boolean(result?.email?.result?.startsWith('valid')))
                .then((valid) => this.previous = { email: email, valid: valid })
                .then((previous) => resolve(previous.valid))
                .catch((error) => resolve(true));
        });
    }

    static applies(input) {
        return input.el.dataset.emailApi !== undefined;
    }
}
